export default __webpack_public_path__ + "static/media/AirCargo2.3e98e3d6.png";